/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/255-sleepy2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM4.854 5.166a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.708.707c-.302-.302-.991-.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5S6.895 8 8 8s2 1.119 2 2.5S9.105 13 8 13zm3.854-7.834a.498.498 0 01-.708 0c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 010 .707z"/>'
  }
})
